/* eslint-disable max-len */
import { chakra, Flex } from '@chakra-ui/react';

import { ClassGroupNavigationSpacing, PagePadding } from '../../../style/constants';
import { APP_HEADING_HEIGHT } from '@containers/app/app-heading/app-heading.styled';
import { CLASS_GROUP_FILTERS_CONTAINER_HEIGHT } from '@containers/class-group-filters/class-group-filters.styled';
import { ACTIVITY_TYPE_TABS_HEIGHT } from '@containers/navigation/activity-type-tabs/activity-type-tabs.styled';

export const container = chakra(Flex, {
    label: 'loading-app-container',
    baseStyle: {
        flexDirection: 'column',
        w: '100%',
        overflow: 'scroll'
    }
});

export const wrapper = chakra(Flex, {
    label: 'loading-app-wrapper',
    baseStyle: {
        paddingLeft: PagePadding.left,
        paddingRight: PagePadding.left,
        alignItems: 'center',
        backgroundColor: 'whiteAlpha.500',
        flexDirection: 'column',
        w: '100%',
        gap: 0
    }
});

export const header = {
    borderRadius: '12px',
    h: CLASS_GROUP_FILTERS_CONTAINER_HEIGHT,
    marginTop: APP_HEADING_HEIGHT,
    w: '100%'
};

export const activityTypes = {
    borderRadius: '100px',
    h: ACTIVITY_TYPE_TABS_HEIGHT,
    mt: {
        base: ClassGroupNavigationSpacing,
        tablet: '17px'
    },
    mb: '9px'
};
